import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=f6a664a0&scoped=true"
import script from "./Forbidden.vue?vue&type=script&lang=js"
export * from "./Forbidden.vue?vue&type=script&lang=js"
import style0 from "./Forbidden.vue?vue&type=style&index=0&id=f6a664a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a664a0",
  null
  
)

export default component.exports